// import { Component, OnInit,Renderer2, Inject } from '@angular/core';
import { Component, OnInit, Inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { WinService } from 'src/app/services/win.service'; 
import { LangService } from 'src/app/services/lang/lang.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionService } from 'src/app/services/session.service';
import { OrderService } from 'src/app/services/api/order.service';
import { ProductService } from 'src/app/services/api/product.service';
import { CartService } from 'src/app/services/api/cart.service';
import { DOCUMENT } from '@angular/common';
import { GtagService } from 'src/app/services/gtag.service';

@Component({
	selector: 'app-confirmation',
	templateUrl: './confirmation.component.html',
	styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent implements OnInit {


	public orderId;
	public orderSummaryLink : any;

	/* list of order items */
	orderItems: any = null;
	/* customPrice: any = null; */

	voucherCode = '';
	voucherDiscountAmount:any = 0;
	itemDiscountTotal:any = 0;

	constructor(
		public winService : WinService,
		public lang : LangService,
		public title : Title,
		public activeRoute: ActivatedRoute,
		public sessionService : SessionService,
		public orderService : OrderService,
		public productService: ProductService,
		public cartService: CartService,
		public router : Router,
		// private _renderer2: Renderer2, 
		@Inject(DOCUMENT) private _document: Document,
		public gtagService: GtagService
	) { }

	ngOnInit() {
		let url = this.router.routerState.snapshot.url;
		let urlSplit = url.split('/');
		if(urlSplit[3] != 'confirmation'){
			let redirectToUrl = '/my/order/confirmation/thankyou/' + this.activeRoute.snapshot.params['orderId'];
			this.router.navigate([redirectToUrl]);
		} else {
			this.title.setTitle('Order Confirmation');
			if(this.sessionService.user.isLogedIn){ 
				this.activeRoute.paramMap.subscribe( urlParam => {
					this.orderId = urlParam.get('orderId');
					this.orderSummaryLink = '/my/order/' + this.orderId + '/summary';

					this.orderService.getOrder(this.orderId).then(order => {
						if(order){
							let o: any = order;
							let sd: any = o.shipping_description.split(' - ');
							o.shipping_description2 = o.shipping_description;
							if(typeof sd[0] != 'undefined'){
								o.shipping_description2 = sd[0];
							}

							// let script = this._renderer2.createElement('script');
							// script.type = `text/javascript`;
							// script.text = `
							// 	gtag('event', 'conversion', {
							// 	'send_to': 'AW-870750764/NkkfCL7n0tcBEKy0mp8D',
							// 	'transaction_id': '${o.increment_id}'
							// });
							// `;

							// this._renderer2.appendChild(this._document.body, script);

							this.gtagService.purchase(order);
							this.gtagService.conversion(order);
					
							/** 
							 * hold the parent item id
							 * so that we can check if there are 2 or mor entries in the order child items
							 * we will only take the first item in row
							 */
							let parentItemId = [];

							this.itemDiscountTotal = 0;
							o.items.forEach(item => {

								if(item.sku.match(/custom-t-shirt/gi)){
									item.sku = 'custom-t-shirt';
									item.parent_item = item;
								}
								if(item.sku.match(/custom-canvas-tote-bag/gi)){
									item.sku = 'custom-canvas-tote-bag';
									item.parent_item = item;
								}

								if(item.parent_item){
									if(!this.orderService.inArray(item.parent_item.item_id, parentItemId)){
										parentItemId.push(item.parent_item.item_id);

										let sku = item.sku;
										sku = sku.replace('-' + item.name, '');
	
										this.itemDiscountTotal += item.parent_item.discount_amount;
	
										this.getAttachment(item, false);
	
										item['cart'] = {
											item_id: item.quote_item_id
										};
										item.parent_item.discount_percent = parseInt(item.parent_item.discount_percent);
										if(item.parent_item.discount_percent > 0){
											item.parent_item['discounted_price'] = item.parent_item.base_price - (item.parent_item.base_price * (item.parent_item.discount_percent / 100));
										}

										if(typeof item.parent_item['additional_data'] != 'undefined'){
											try {
												item.parent_item['additional_data'] = JSON.parse(item.parent_item['additional_data']);
												item.parent_item['additional_data']['sticker_pad'] = item.parent_item['additional_data']['sticker_pad'] + ''; /** make string */
											} catch (error) {
												/** do nothing */
											}
										}
										
	
										this.productService.getProductBySku(sku).then(perProd => {
											let product: any = perProd;
											item['product'] = product;
	
											let custom_options = item.parent_item.product_option.extension_attributes.custom_options
	
											let opts = product.options;
											// opts.forEach(opt => {
											// 	if(opt.title == 'custom size'){
											// 		custom_options.forEach(co => {
											// 			if(opt.option_id == co.option_id){
											// 				let coSize = co.option_value.split(' x ');
											// 				if(coSize.length == 2){
											// 					item.parent_item['option_value'] = coSize[0] + ' cm x ' + coSize[1] + ' cm';
											// 				}
											// 			}
											// 		});
											// 	}
											// });
	
											item['custom_options'] = [];
											custom_options.forEach((option, key) => {
												opts.forEach(opt => {
													if(parseInt(option.option_id) == opt.option_id){
														if(opt.product_sku == 'custom-t-shirt'){ /** for t-shirt */
															custom_options[key]['title'] = opt.title;
															if(opt.title == 'Color'){
																custom_options[key]['option_value'] = this.getOptionValueTitle(opt, custom_options[key]);
																custom_options[key]['option_value'] = custom_options[key]['option_value'].split('-');
																custom_options[key]['option_value'] = custom_options[key]['option_value'][0];
																item['custom_options'].push(custom_options[key]);
															}
															else if(opt.title == 'Print Location'){
																custom_options[key]['option_value'] = this.getOptionValueTitle(opt, custom_options[key]);
																item['custom_options'].push(custom_options[key]);
															}
															else if(this.cartService.inArray(opt.title, ['Size-XS','Size-S','Size-M','Size-L','Size-XL','Size-XXL','Size-XXXL'])){
																if(custom_options[key]['option_value']){
																	custom_options[key]['title']  = opt.title.replace('-', ' Qty ');
																	item['custom_options'].push(custom_options[key]);
																}
															}
															else if(this.cartService.inArray(opt.title, ['Front Size', 'Back Size', 'Left Arm Size', 'Right Arm Size', 'Inside Tag Size'])){
																custom_options[key]['title']  = opt.title;
																item['custom_options'].push(custom_options[key]);
															}
														}
														else if(opt.product_sku == 'custom-canvas-tote-bag'){
															custom_options[key]['title'] = opt.title;
	
															if(opt.title == 'Sizes' || opt.title == 'Print Location'){
																custom_options[key]['option_value'] = this.getOptionValueTitle(opt, custom_options[key]);
																item['custom_options'].push(custom_options[key]);
															}
															else if(opt.title == 'Front Print Size' || opt.title == 'Back Print Size'){
																item['custom_options'].push(custom_options[key]);
															}
														}
														else {
															if(opt.title == 'custom size'){
																custom_options[key]['title'] = 'size';
																let coSize = custom_options[key]['option_value'].split(' x ');
																if(coSize.length == 2){
																	custom_options[key]['option_value'] = coSize[0] + ' cm x ' + coSize[1] + ' cm';
																}
																item['custom_options'].push(custom_options[key]);
															}
															else if(opt.title == 'adhesive'){
																custom_options[key]['title'] = opt.title;
																item['custom_options'].push(custom_options[key]);
															}
															else if(opt.title == 'cutting type'){
																custom_options[key]['title'] = opt.title;
																item['custom_options'].push(custom_options[key]);
																opt.values.forEach(optVal => {
																	if(optVal.option_type_id + '' == custom_options[key]['option_value']){
																		custom_options[key]['option_value'] = optVal.title;
																	}
																});
															}
														}
													}
												});
											});
										});
	
										this.productService.getProductImage(item.parent_item.product_id, 150, 150).then(pImage => {
											if(pImage){
												item.parent_item['images'] = pImage;
											}
										});

										if(!this.orderItems){
											this.orderItems = [item];
										} else {
											this.orderItems.push(item);
										}
									}
								}
							});

							if(typeof o['coupon_code'] != 'undefined'){
								this.voucherCode = o['coupon_code'];
								this.voucherDiscountAmount = o.discount_amount - this.itemDiscountTotal;
							} else {
								this.voucherCode = '';
								this.voucherDiscountAmount = 0;
							}
						} else {
							this.router.navigate(['/']);
						}
					});

				});
			}else{
				this.router.navigate(['/']);
			} 
		}
	}

	getOptionValueTitle(opt:any, co:any){
		let title = [];
		opt.values.forEach(optValue => {
			let coOptionValues = co.option_value.split(',');
			coOptionValues.forEach(coOptionValue => {
				if(coOptionValue + '' ==  optValue.option_type_id + '' ){
					title.push(optValue.title);
				}
			});
		});
		return title.join(', ');
	}

  /**
   * get the attachment from api request
   */
  getAttachment(item, activateLoader:boolean = false){
    if(activateLoader){
      this.productService.setLoader(true);
    }

    let attachUrl = '/rest/entrelable/V1/lns-orderattachment/attachment/' + item.parent_item.quote_item_id
    this.productService.makeRequest(attachUrl, '', 'GET').then(attach => {
      let attch: any = attach;
      if(attch && typeof attch[0] != 'undefined'){
        if(attch.length){
          let attachment = attch[0];
          if(typeof attachment.id != 'undefined'){
            item.attachment = attachment;
          }
        }
      }
      if(activateLoader){
        this.productService.setLoader(false);
      }
    });
  }

  /**
	 * check if there is an paymay fee
	 */
	get paymayFee(){
		let result: any = '';
		if(this.orderService.order){
      let order = this.orderService.order;
      if(order.payment.method == 'paymaya' || order.payment.method == "dragonpay"){
        let subtotal = (order.subtotal - order.discount_amount) + order.shipping_amount;
        subtotal = order.base_grand_total - subtotal;
        result = ''+subtotal;
      }
		}
		return result;
	}
}
